import { render, staticRenderFns } from "./GraphChallenge.md?vue&type=template&id=3399379e&"
import script from "./GraphChallenge.md?vue&type=script&lang=js&"
export * from "./GraphChallenge.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports